/* eslint-disable no-undef */
const ref = typeof Vue !== 'undefined' ? Vue.ref : null;
const watch = typeof Vue !== 'undefined' ? Vue.watch : null;

const template = `
	<div class="ubf-dynamicList__filter ubf-dynamicList__filter--number">
		<input type="number" class="ubf-dynamicList__input" :value="localValue" @input="onInput" @change="onChange" size="5"/>
	</div>
`;

export default {
    emits: ['input', 'change'],
    template: template,
    props: {
        label: String,
        value: [Number, String],
        description: String
    },
    setup: function (props, context) {
		const localValue = ref(props.value);
		watch(
			() => props.value, (newVal) => {localValue.value = newVal;}
		);
		return {
			localValue: localValue,
            label: props.label,
            description: props.description
        };
    },
	methods: {
		onInput: function(event) {
			this.$emit('input', event.target.value);
		},
		onChange: function(event) {
			this.$emit('change', event.target.value);
		},
	},
};

